import React from 'react';
import PropTypes from 'prop-types';

const Suggestion = ({ geocodingAddresses, handleSuggestion, isColFull, handleOnblur }) => (
  <div
    className={`list-group autocomplete-list autocomplete-list-new ${isColFull ? 'col-md-12' : 'col-md-8'}`}
    tabIndex="-1"
    onBlur={handleOnblur}
  >
    {geocodingAddresses.map((val, index) => (
      <a
        onClick={() => handleSuggestion(index, val)}
        key={index}
        id={index}
        href="javascript:void(0);"
        className="list-group-item"

        tabIndex="0"
        suggestion-item="true"
        onBlur={handleOnblur}
        onKeyPress={event => {
          event.stopPropagation();
          if (event.key === 'Enter') {
            handleSuggestion(index, val)
          }
        }}
      >
        {val.suggestionAddress}
      </a>
    ))}
  </div>
);
Suggestion.defaultProps = {
  isColFull: false
};
Suggestion.propTypes = {
  geocodingAddresses: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSuggestion: PropTypes.func.isRequired,
  isColFull: PropTypes.bool,
};

export default Suggestion;
